import { render } from "./train.vue?vue&type=template&id=5cf3d2d8&scoped=true"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5cf3d2d8&scoped=true&lang=scss"
import "./train.vue?vue&type=style&index=1&id=5cf3d2d8&scoped=true&lang=scss"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf3d2d8"]])

export default __exports__